export const GITHUB_OAUTH_STATE_KEY = 'github_oauth_state'

export function saveGithubOAuthState(state, storage = window.sessionStorage) {
  const value = String(state || '')
  if (!value) throw new Error('后端未返回 GitHub 登录状态')
  storage.setItem(GITHUB_OAUTH_STATE_KEY, value)
}

export function readGithubOAuthCallback(
  search,
  storage = window.sessionStorage,
) {
  const params = new URLSearchParams(search)
  const state = String(params.get('state') || '')
  const expectedState = String(storage.getItem(GITHUB_OAUTH_STATE_KEY) || '')

  if (!state || !expectedState || state !== expectedState) {
    throw new Error('GitHub 登录状态校验失败，请重新发起登录')
  }

  storage.removeItem(GITHUB_OAUTH_STATE_KEY)

  const oauthError = params.get('error_description') || params.get('error')
  if (oauthError) throw new Error(oauthError)

  const code = String(params.get('code') || '')
  if (!code) throw new Error('GitHub 登录回调缺少授权 code')

  return { code, state }
}
